import React from "react";
import { View } from "react-native";
import { SignupProvider } from "./SignupProvider";
import Logo from "./logo";
import Screens from "./screens";
import useStyles from "./styles.css";
import Background from "./background";
import LogoTop from "./logo-top";
import { tabletSize } from "@src/utils/screensize-helper";

const Signup = () => {
  const styles = useStyles();
  const isTablet = tabletSize();

  return (
    <SignupProvider>
      <View style={styles.container}>
        <Background />
        <View style={styles.v_body}>
          { isTablet ? <LogoTop/> : <Logo /> }
          <Screens />
        </View>
      </View>
    </SignupProvider>
  );
};

export default Signup;
